<ng-container *transloco="let t; read: 'home'">
  <section class="teaser">
    <div class="teaser-pics">
      <div
        class="teaser teaser1"
        [ngStyle]="{ backgroundImage: images[0] }"
        [ngClass]="{ active: teaserIndex === 0 }"
      ></div>
      <div
        class="teaser teaser2"
        [ngStyle]="{ backgroundImage: images[1] }"
        [ngClass]="{ active: teaserIndex === 1 }"
      ></div>
    </div>
    <div class="content">
      <div class="title">video2manual</div>
      <div class="sub">{{ t("slogan") }}</div>
    </div>
  </section>
  <section class="headliner">
    <h2 [innerHTML]="t('what-title')"></h2>
    <p>
      {{ t("what-text") }}
    </p>
    <a class="call" [routerLink]="['/utility-film-definition']">{{
      t("more-button")
    }}</a>
  </section>
  <section class="headliner">
    <h2 [innerHTML]="t('why-title')"></h2>
    <div [innerHTML]="t('why-content')"></div>
    <a class="call" [routerLink]="['/reasons']">{{ t("more-button") }}</a>
  </section>
  <section class="blocks inverted">
    <div class="blocks">
      <article>
        <a
          class="block-link"
          [routerLink]="['/benefit']"
          fragment="knowledgeTransfer"
        >
          <div><img src="assets/icon_kopf.png" /></div>
          <h3>{{ t("knowledge-transfer-title") }}</h3>
          <div>
            {{ t("knowledge-transfer-text") }}
          </div>
        </a>
      </article>
      <article>
        <a
          class="block-link"
          [routerLink]="['/benefit']"
          fragment="companyDevelopment"
        >
          <div><img src="assets/icon_team.png" /></div>
          <h3>{{ t("company-development-title") }}</h3>
          <div>
            {{ t("company-development-text") }}
          </div>
        </a>
      </article>
      <article>
        <a class="block-link" [routerLink]="['/benefit']" fragment="costSaving">
          <div><img src="assets/icon_kostenersparnis.png" /></div>
          <h3>{{ t("cost-saving-title") }}</h3>
          <div>
            {{ t("cost-saving-text") }}
          </div>
        </a>
      </article>
    </div>
  </section>
  <section class="blocks">
    <h2 [innerHTML]="t('top-functions-title')"></h2>
    <div class="blocks">
      <article class="same-height">
        <div>
          <div><img src="assets/bild-einlesen.png" /></div>
          <h3>{{ t("read-image-title") }}</h3>
          <div>
            {{ t("read-image-text") }}
          </div>
        </div>
        <a class="call" (click)="openModal('video1')">{{
          t("video-button")
        }}</a>
      </article>
      <article class="same-height">
        <div>
          <div><img src="assets/schnappschuss.png" /></div>
          <h3>{{ t("snapshot-title") }}</h3>
          <div>
            {{ t("snapshot-text") }}
          </div>
        </div>
        <a class="call" (click)="openModal('video2')">{{
          t("video-button")
        }}</a>
      </article>
      <article class="same-height">
        <div>
          <div><img src="assets/kopieren.png" /></div>
          <h3>{{ t("copy-title") }}</h3>
          <div>
            {{ t("copy-text") }}
          </div>
        </div>
        <a class="call" (click)="openModal('video3')">{{
          t("video-button")
        }}</a>
      </article>
    </div>
  </section>
  <v2m-image-ticker
    [title]="t('references-title')"
    [images]="[
      'assets/Brose_Logo_Website_weiß.png',
      'assets/Hiller_Logo_Website_weiß.png',
      'assets/MTU_Logo_Website_weiß.png',
      'assets/SAF_Logo_Website_weiß.png',
      'assets/Teepack_Logo_Website_weiß.png',
      'assets/Weber_Logo_weiß.png'
    ]"
  ></v2m-image-ticker>
  <section class="citation">
    <div class="citation">
      <div class="picture"><img src="assets/csm_zitat.jpg" /></div>
      <div class="text" [innerHTML]="t('citation-content')"></div>
      <div class="contact" [innerHTML]="t('citation-person')"></div>
      <div class="call">
        <a class="call" [routerLink]="['/contact']">{{ t("citation-call") }}</a>
      </div>
    </div>
  </section>
  <v2m-modal id="video1">
    <h3>Bild einlesen</h3>
    <div class="player">
      <video
        controls
        src="https://www.video2manual.de/videos/bilder-einlesen.mp4"
      ></video>
      <button class="close" (click)="closeModal('video1')">
        <i class="material-icons">close</i>
      </button>
    </div>
  </v2m-modal>
  <v2m-modal id="video2">
    <h3>Schnappschuss-Button</h3>
    <div class="player">
      <video
        controls
        src="https://www.video2manual.de/videos/schnappschuss.mp4"
      ></video>
      <button class="close" (click)="closeModal('video2')">
        <i class="material-icons">close</i>
      </button>
    </div>
  </v2m-modal>
  <v2m-modal id="video3">
    <h3>Kopieren von Elementen</h3>
    <div class="player">
      <video
        controls
        src="https://www.video2manual.de/videos/bilder-einlesen.mp4"
      ></video>
      <button class="close" (click)="closeModal('video3')">
        <i class="material-icons">close</i>
      </button>
    </div>
  </v2m-modal>
</ng-container>
